// extracted by mini-css-extract-plugin
export default {"privacy-and-policy":"PrivacyPolicy_privacy-and-policy__u86vG","font-weight-bold":"PrivacyPolicy_font-weight-bold__HnT2y","font-style-italic":"PrivacyPolicy_font-style-italic__5OfLP"};